module.exports = __webpack_public_path__ + "img/vivo.4507563a.svg";